import { slugify } from '@/helpers';
import { ServicesContainer } from '@/services';
import { NutritionLinkClickEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, NutritionLinkClickType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeNutritionLinkClickEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LinkClicked;

  constructor(event: NutritionLinkClickEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    const topLevelMenuItemTitle = store.state.mealBuilderV2.topLevelMenuItem?.title;		

    this.web.webInteraction = {
      linkClicks: { value: 1 },
      name: event.nutritionClickEventType,
      type: 'nutrition-calculator',
    };

    switch(event.nutritionClickEventType) {
      case NutritionLinkClickType.MealSelectAllergenStatement:
        this.web.webInteraction.linkModuleName = 'nutrition-caclulator|link|allergen-statement';
        break;
      case NutritionLinkClickType.AllergenStatement: 
      case NutritionLinkClickType.FullNutritionFacts:
        this.web.webInteraction.linkModuleName = 'nutrition-caclulator|meal-' + slugify(topLevelMenuItemTitle ?? '') + '|' + event.nutritionClickEventType;
        break;
      case NutritionLinkClickType.NutritionPreferences:
        this.web.webInteraction.linkModuleName = 'nutrition-calculator|select|nutrition-preferences';
        break;
      case NutritionLinkClickType.NutritionPreferencesApply:
        const plantBasedTags = this.getTagCodesForGroup('Plant Based', store);
        const lifeStyleTags = this.getTagCodesForGroup('Lifestyle', store);
        const avoidingGroupTags = this.getTagCodesForGroup(`I'm Avoiding`, store);
      
        let includedGroups = [];
        if (plantBasedTags?.length) {
          includedGroups.push('plant-based');
        }
        if (lifeStyleTags?.length) {
          includedGroups.push('lifestyle');
        }
        if (avoidingGroupTags?.length) {
          includedGroups.push('im-avoiding');
        }
        this.web.webInteraction.linkModuleName = includedGroups.join('|');
        this.account.nutritionPrefs = { value: 1 };
        break;
      case NutritionLinkClickType.ViewAllIngredients:
        this.web.webInteraction.linkModuleName = 'nutrition-calculator|ingredients|view-all';
        break;
      case NutritionLinkClickType.NutritionBreakdown:
        this.web.webInteraction.linkModuleName = slugify(event.entree?.menuItemName || '') + '|view-full-nutrition-breakdown';
        this.web.webInteraction.nutritionData = event.nutrition?.tcal + '|' + event.nutrition?.tfat + '|' + event.nutrition?.prot + '|' + event.nutrition?.carb;
        break;
      case NutritionLinkClickType.SelectYourMeal:
        this.web.webInteraction.linkModuleName = slugify(topLevelMenuItemTitle!) + '|select-your-meal';
        break;
    }
  }

  private getTagCodesForGroup(groupName: string, store: Store<AppState>) {
    const customerProfileTags = store.state.customer.profile?.dietaryTags;
    const tagGroups = store.state.menu.metadata?.dietaryTagGroups 
    return tagGroups?.find(g => g.groupName === groupName)?.tags?.filter(t => customerProfileTags?.includes(t.tagCode)).map(x => x.tagCode);
  }
}